export const TABLE_THROTTLING_DELAY = 1000

export const TABLE_WHEEL_DELTA = 0
